var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 601.26,
    height: 162.665,
    viewBox: "0 0 601.26 162.665",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_74",
    "data-name": "Rectangle 74",
    d: "M0,0H102.044a29.909,29.909,0,0,1,29.909,29.909V162.665a0,0,0,0,1,0,0H29.909A29.909,29.909,0,0,1,0,132.756V0A0,0,0,0,1,0,0Z",
    transform: "translate(489.563 562.405)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_400",
    "data-name": "Path 400",
    d: "M564.963,625.959s-13.529-3.034-19.946-.528c-8.824,3.446-11.507,13.212-13.421,17.974,1.6,4.14,8.41,7.949,13.827,9.938l58.256,21.326L604,642.637Z",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.384,
    y1: 0.652,
    x2: 2.038,
    y2: -1.512,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#04841f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#00af2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04841f"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_401",
    "data-name": "Path 401",
    d: "M552.29,596.871c-10.929,4.258-20.694,8.269-20.694,17.1v29.435c3.306-8.225,33.367-17.446,33.367-17.446l38.5-13.833L603.688,577Z",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -0.032,
    y1: 0.827,
    x2: 1.137,
    y2: 0.109,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#04841f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00af2d"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_403",
    "data-name": "Path 403",
    d: "M583.306,689.938C594.235,685.68,604,681.67,604,672.84V643.405c-3.306,8.224-33.368,17.445-33.368,17.445l-38.5,13.834-.228,35.124Z",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1.032,
    y1: 0.173,
    x2: -0.137,
    y2: 0.891,
    xlinkHref: "#linear-gradient-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_530",
    "data-name": "Group 530",
    transform: "translate(-489.563 -562.405)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_73",
    "data-name": "Rectangle 73",
    d: "M0,0H102.044a29.909,29.909,0,0,1,29.909,29.909V162.665a0,0,0,0,1,0,0H29.909A29.909,29.909,0,0,1,0,132.756V0A0,0,0,0,1,0,0Z",
    transform: "translate(489.563 562.405)",
    fill: "#a8e4a0"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Turning_insights_into_rewards",
    "data-name": "Turning insights into rewards",
    transform: "translate(658.63 709.994)",
    fill: "#00af2d",
    fontSize: 31,
    fontFamily: "Ubuntu-Medium, Ubuntu",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Turning insights into rewards")), /*#__PURE__*/React.createElement("g", {
    id: "Group_519",
    "data-name": "Group 519"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_518",
    "data-name": "Group 518"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_393",
    "data-name": "Path 393",
    d: "M908.041,663.2c-16.539,17.933-38.275,12.631-47.752,1.681-11.8-13.636-11.245-32.85,1.03-45.24,10.379-10.477,32.1-14.529,46.479,3.163V612.517h7.5v60.828h-7.261Zm-24.051,4.7c13.871,0,24.529-10.717,24.553-24.695.024-14.258-10.551-25.171-24.4-25.174a24.6,24.6,0,0,0-24.53,24.813C859.562,656.505,870.64,667.9,883.99,667.9Z",
    fill: "#007513"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_394",
    "data-name": "Path 394",
    d: "M719.172,674.934c-18.215-.08-31.73-13.872-31.657-32.306.071-17.989,14.436-32.391,32.078-32.16,18.134.237,31.938,14.586,31.727,33.209C751.139,659.589,738.309,675.521,719.172,674.934Zm-23.98-31.919c-.023,13.809,10.76,24.875,24.19,24.824a24.33,24.33,0,0,0,24.147-24.524c.1-13.83-10.843-25.25-24.179-25.238C706.12,618.088,695.215,629.345,695.192,643.015Z",
    fill: "#007513"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_395",
    "data-name": "Path 395",
    d: "M998.834,624.678c-1.918,1.215-3.427,2.188-4.956,3.129a7.3,7.3,0,0,1-1.125.468c-11.852-14.71-33.176-12.3-42.1-2.169a25.2,25.2,0,0,0,1.347,34.8c8.846,8.641,28.269,11.28,40.671-3.67l5.994,3.921a29.433,29.433,0,0,1-18.507,12.574c-11.258,2.571-21.967,1.588-31.444-5.7-9.842-7.564-13.648-17.8-11.819-29.81,1.833-12.026,8.818-20.528,20.135-25.122,12.821-5.205,29.329-2.14,37.988,6.853C996.324,621.322,997.408,622.9,998.834,624.678Z",
    fill: "#007513"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_396",
    "data-name": "Path 396",
    d: "M837.439,595.232a73.435,73.435,0,0,0-8.685-.824,4.289,4.289,0,0,0-4.577,4.643c-.03,4.319-.007,8.638-.007,13.162h12.509v6.377H823.943v54.789H816.1V618.822h-7.588v-6.451c2.3,0,4.967-.025,7.528-.025.261-5.077.39-9.785.436-14.521.086-9.024,8.021-11.506,14.071-10.9a31.859,31.859,0,0,1,7.13,1.373Z",
    fill: "#007513"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_397",
    "data-name": "Path 397",
    d: "M658.379,589.489h7.649v22.7h12.2v6.528H666.115v54.639h-7.6V618.917H647.844v-6.65c2.631,0,8.338.07,10.614.035h-.038C658.309,605.717,658.379,596.4,658.379,589.489Z",
    fill: "#007513"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_398",
    "data-name": "Path 398",
    d: "M1020.379,589.489h7.649v22.7h12.2v6.528h-12.109v54.639h-7.6V618.917h-10.672v-6.65c2.631,0,8.338.07,10.614.035h-.038C1020.309,605.717,1020.379,596.4,1020.379,589.489Z",
    fill: "#007513"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_399",
    "data-name": "Path 399",
    d: "M776.816,620.994c8.663-10.461,15.523-12.786,22.714-8.148l-3.572,5.853c-10.584-1.274-17.761,5.038-18.34,16.692-.564,11.341-.508,22.714-.718,34.073-.023,1.248,0,2.5,0,3.91h-7.962V612.537h7.881Z",
    fill: "#007513"
  }), /*#__PURE__*/React.createElement("text", {
    id: "S",
    transform: "translate(1047.823 673.465)",
    fill: "#007513",
    fontSize: 86.831,
    fontFamily: "MyriadPro-Regular, Myriad Pro"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "S")))), /*#__PURE__*/React.createElement("g", {
    id: "Group_521",
    "data-name": "Group 521"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_520",
    "data-name": "Group 520",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_64",
    "data-name": "Line 64",
    x1: 199.998,
    y2: 39.281,
    transform: "translate(427.312 625.136)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 15.312
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_523",
    "data-name": "Group 523"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_522",
    "data-name": "Group 522",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_75",
    "data-name": "Rectangle 75",
    width: 72.404,
    height: 51.745,
    transform: "translate(531.596 622.925)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("line", {
    id: "Line_65",
    "data-name": "Line 65",
    y2: 162,
    transform: "translate(569.567 563)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 13.154
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_66",
    "data-name": "Line 66",
    y2: 21.666,
    transform: "translate(569.567 574.127)",
    fill: "none",
    stroke: "#009620",
    strokeMiterlimit: 10,
    strokeWidth: 13.154
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_67",
    "data-name": "Line 67",
    y2: 21.666,
    transform: "translate(569.567 692.516)",
    fill: "none",
    stroke: "#009620",
    strokeMiterlimit: 10,
    strokeWidth: 13.154
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_525",
    "data-name": "Group 525"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_524",
    "data-name": "Group 524",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_76",
    "data-name": "Rectangle 76",
    width: 72.092,
    height: 66.403,
    transform: "translate(531.596 577.002)",
    fill: "url(#linear-gradient-2)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_402",
    "data-name": "Path 402",
    d: "M531.756,612.075a11.084,11.084,0,0,0-.16,1.894v29.436c3.14-7.812,30.415-16.522,33.144-17.376Z",
    fill: "#007513",
    fillRule: "evenodd",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_527",
    "data-name": "Group 527"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_526",
    "data-name": "Group 526",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_77",
    "data-name": "Rectangle 77",
    width: 72.092,
    height: 66.403,
    transform: "translate(531.908 643.405)",
    fill: "url(#linear-gradient-3)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_404",
    "data-name": "Path 404",
    d: "M603.992,643.422c-3.342,8.22-33.36,17.428-33.36,17.428l-2.373.853,35.42,12.966Z",
    fill: "#007513",
    fillRule: "evenodd",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_529",
    "data-name": "Group 529"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_528",
    "data-name": "Group 528",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_78",
    "data-name": "Rectangle 78",
    width: 153,
    height: 20,
    transform: "translate(480 554)",
    fill: "#009620"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.672bcfcb91dc2e97db8f86f61a8fd5de.svg";
export { ForwardRef as ReactComponent };